import { Plugin } from "@nuxt/types"
import { Client } from "raygun"

import SohoApi from "../utils/SohoApi/SohoApi"

declare module "vue/types/vue" {
  interface Vue {
    $sohoApi: SohoApi
    $raygun: Client
  }
}

declare module "@nuxt/types" {
  interface NuxtAppOptions {
    $sohoApi: SohoApi
    $raygun: Client
  }
}

declare module "vuex/types/index" {
  interface Store<S> {
    $sohoApi: SohoApi
  }
}

const sohoApi: Plugin = ({ app }, inject) => {
  inject(
    "sohoApi",
    new SohoApi({
      axios: app.$axios,
      errorHandler: app.$raygun && app.$raygun.send
    })
  )
}

export default sohoApi
